import React from 'react';
import ReactDOM from 'react-dom';

class ReactPortal extends React.Component {
  constructor() {
    super();

    /*
     * Create our own element to render to, because it's not recommended to
     * render directly to the body.
     */
    if (__CLIENT__) {
      this.el = document.createElement('div');
    }
  }

  /*
   *React LifeCycle to mount after render
   */
  componentDidMount() {
    document.body.appendChild(this.el);
  }

  /*
   *React LifeCycle to unmount component
   */
  componentWillUnmount() {
    if (__CLIENT__) {
      document.body.removeChild(this.el);
    }
  }

  render() {
    /*
     * Here we are using React portal which provides way to render children in to a DOM node
     * that exits outside of the DOM hierarchy of parent component. Here, it renders
     * to our an element which isn't yet attached to the DOM.
     */
    return (this.el && ReactDOM.createPortal(this.props.children, this.el)) || null;
  }
}

export default ReactPortal;
